export default __webpack_public_path__ + "static/media/1411.82956b3d.png";